import ComponentCorrespondentImagemAlternativas from "models/componentInteraction/ComponentCorrespondentImagemAlternativas";
import { GenericService } from "../Generic.service";


export class ComponentCorrespondentImagemService extends GenericService {
    readonly URI: string = '/v1/componentCorrespondentImagem';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public saveAlternativa(idCorrespondentImagem: number, body: ComponentCorrespondentImagemAlternativas) {
        return this.post("alternativa/" + idCorrespondentImagem, body);
    }

     public deleteByAlternativa(idAlternativa: number) {
        return this.deleteByUrl(idAlternativa, "alternativa");
    }
}